var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C15.06 8 14.5 8.56 14.5 9.25V15H14C12.35 15 11 16.35 11 18H10C10 15.96 11.53 14.28 13.5 14.03V3.25C13.5 2.56 12.94 2 12.25 2C11.56 2 11 2.56 11 3.25V11H10V1.25C10 0.56 9.44 0 8.75 0C8.06 0 7.5 0.56 7.5 1.25V11H6.5V2.75C6.5 2.06 5.94 1.5 5.25 1.5C4.56 1.5 4 2.06 4 2.75V12H3V5.75C3 5.06 2.44 4.5 1.75 4.5C1.06 4.5 0.5 5.06 0.5 5.75V15.75C0.5 20.31 4.19 24 8.75 24C13.31 24 17 20.31 17 15.75V9.25C17 8.56 16.44 8 15.75 8Z",
    fill: "#F47721"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusBlock);
export default __webpack_public_path__ + "static/media/status_block.75273a3cb3cff569aa2c96fe2d509811.svg";
export { ForwardRef as ReactComponent };